import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=eed15750&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style0 from "./banner.vue?vue&type=style&index=0&id=eed15750&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed15750",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoreLink: require('D:/Project/kpwebsite/PC/components/moreLink/index.vue').default})
